export enum OgType {
    ARTICLE = "article"
}
